import './SubscriptionManagementNew.scss';

import React, { useEffect, useState } from 'react';

import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import { LandingPage } from '@bmsp/bmsp.webcomponent.subscription.management';
import { User } from 'oidc-client';
import authService from '../../../authService';
import { getFeatureFlagValuebasedOnSIOrg, getFeatureFlagValuebasedOnSIOrgWhitelist } from '../../commonUtils/LDFlagUtils';
import i18next from '../../../i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface ISubscriptionManagementNewProps {
  loggedInUser: User | null;
}

export const SubscriptionManagementNew: React.FC = () => {
  const orgSelected = useSelector(
    (state: IOrganisationState) =>
      state.globalShared.gatewaySelectedOrganisation
  );
  const history = useHistory();
  useEffect(() => {
    const handleNavigation = (event: CustomEvent) => {
      const { path, params } = event.detail;
      const fullPath = `${path}?${new URLSearchParams(params)}`;
      history.push(fullPath);
    };

    window.addEventListener(
      'bmsp:organization-subscription-tab',
      handleNavigation as EventListener
    );
    return () => {
      window.removeEventListener(
        'bmsp:organization-subscription-tab',
        handleNavigation as EventListener
      );
    };
  }, [history]);



    const featureFlags = useFlags();
    const HBS_ORGANIZATION_LIST = (window as any).ENV.HBSORG_LIST;
    const organisations = useSelector(
        (state: IOrganisationState) => state.globalShared.organisationList);

        let subscriptionStatus = '';
        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.has('subs-status')) {
            subscriptionStatus = queryParams.get('subs-status') || '';
        }
       const enableArrLicenseFlowForSi =  getFeatureFlagValuebasedOnSIOrgWhitelist(
                'enableArrLicenseFlowForSi',
                featureFlags,
                orgSelected,
                organisations
              )

    const subscriptionManagementProps = { ...orgSelected, featureFlags: { ...featureFlags , enableBacsFlowDistributor: featureFlags['enableBacsFlowDistributor'] ?? false, enableARRLicenseManagement:enableArrLicenseFlowForSi }, globalPermissions: authService.globalPermissions, i18Lng: i18next as any, subscriptionStatus, hbsOrganizationList: HBS_ORGANIZATION_LIST};
    return (
        <>
            <div className='new-subscription-container'>
                {orgSelected && <LandingPage {...subscriptionManagementProps}  />}
            </div>
        </>
    )
}
export default SubscriptionManagementNew;
